import { IntNumberInput } from "@/shared/components/domain/qpm/inputs/number-input";
import { Label } from "@/shared/components/ui/label";
import { useQpmCatalogItemSetRecommendedVisitsMutation } from "@/services/backend/qpm/catalog/api/catalog-api";
import { usePersistenceContext } from "@/shared/lib/persistence-state/context";
import { PersistenceState } from "@/shared/lib/persistence-state/persistence-state";

export function CatalogItemVisitsComponent({
  catalogItemId,
  value,
}: {
  catalogItemId: string;
  value: number;
}) {
  const [update] = useQpmCatalogItemSetRecommendedVisitsMutation();
  const { setPersistenceState } = usePersistenceContext();

  const persist = (perYear: number) => {
    setPersistenceState(PersistenceState.SAVING);
    update({ catalogItemId, perYear })
      .unwrap()
      .then(() => setPersistenceState(PersistenceState.SAVED))
      .catch(() => setPersistenceState(PersistenceState.ERROR));
  };

  return (
    <div className="grid grid-cols-4 gap-1.5">
      <Label className="col-span-2" htmlFor="recommended-visits">
        Empfohlene Maßnahmen/Jahr
      </Label>
      <div className="col-span-2">
        <IntNumberInput
          className=""
          id="recommended-visits"
          value={value}
          onBlur={persist}
        />
      </div>
    </div>
  );
}
